"use client";
import { useEffect } from "react";
import Button from "@/components/common/Button";
import { twMerge } from "tailwind-merge";
import { useIsDark } from "@/context/ThemeContext";

export default function NotFound() {
  const isdark = useIsDark();

  useEffect(() => {
    const navbar = document.querySelector("nav");
    const footer = document.querySelector("footer");

    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";

    return () => {
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen bg-[#020409] text-white text-center overflow-hidden">
      {/* Bottom Left Blue Glow 1 */}
      <div className="absolute w-[315px] h-[380px] bg-[#2AA0E7] rounded-full blur-[184px] opacity-40 rotate-[139deg] -left-40 bottom-[140px]" />

      <div className="absolute w-[313px] h-[375px] bg-[#A1ADF5] rounded-full blur-[148px] opacity-40 rotate-[139deg] left-20 bottom-[40px]" />

      {/* Top Right Pink Glow */}
      <div className="absolute w-[301px] h-[349px] bg-[#FFBDFB] rounded-full blur-[148px] opacity-40 rotate-[-71deg] right-[-80px] top-[50px]" />
      <div className="absolute w-[316px] h-[368px] bg-[#2A40E7] rounded-full blur-[185px] opacity-40 rotate-[-71deg] right-[-80px] top-[-140px]" />

      <h1 className="text-center font-alexandria font-bold text-[120px] laptop:text-[283px] leading-[100%] tracking-[4%] mb-8 bg-gradient-to-b from-[#FF00EA] to-[#2600FC] text-transparent bg-clip-text drop-shadow-[0_0_30px_rgba(255,0,234,0.3)]">
        404
      </h1>

      <h2 className="font-alexandria font-semibold text-[42px] laptop:text-[52px] leading-[100%] uppercase text-[#1a1a1a] dark:text-[#ffffff] mb-6">
        OOPS! AUTHOR NOT FOUND
      </h2>
      <p className="font-alexandria font-semibold text-[25px] laptop:text-[35px] leading-[100%] text-center capitalize text-[#adadad] mb-8">
        We couldn&#39;t find the author you&#39;re looking for.
      </p>

      <Button
        label="Go to blog page"
        href="/blog"
        className={twMerge(isdark ? "" : "bg-[#DF27DF]")}
      />
    </div>
  );
}
